window.AsideDireita = {
    renderizarAba: true,
    fixado: 'False',
    load: function () {
    },

    show: function(nome) {

        if (nome && !this.renderizarAba) {
            $("[aside-direita-action]").attr("aside-direita-action", nome);
        }

        if (!nome) {
            nome = $("[aside-direita-action]").attr("aside-direita-action");
        }

        $("[aside-direita-action]").addClass("ativo");
        $('#corpo_BaseInterno').css('margin-right', '230px');
        $('.icone-topo').css('right', '230px');
        $('.botao-flutuante-cesta-produtos').css('right', '254px');
        $("[aside-direita]").removeClass('oculto');
        $("[aside-direita]").removeClass('control-sidebar-open');
        $("[aside-direita]").hide();

        if (nome) {
            $("[aside-direita=" + nome + "]").addClass('control-sidebar-open');
            $("[aside-direita=" + nome + "]").show();
        }
    },

    hide: function() {

        var visibleAside = $(".control-sidebar-open");

        if (visibleAside && visibleAside.length > 0) {
            $("[aside-direita-action]").attr("aside-direita-action", visibleAside.attr("aside-direita"));
        }

        $("[aside-direita-action]").removeClass("ativo");
        $('#corpo_BaseInterno').css('margin-right', '');
        $('.icone-topo').css('right', '0');
        $('.botao-flutuante-cesta-produtos').css('right', '24px');
        $("[aside-direita]").addClass('oculto');
        $("[aside-direita]").removeClass('control-sidebar-open');
    },

    fixar: function (fixar) {
        var self = this;

        global.ajax({
            url: '/Usuario/MenuTotalFixado',
            type: 'post',
            data: { fixado: fixar },
            success: function () {
                self.fixado = fixar;
            }
        });
    },

    actionClick: function(e) {

        if ($(e.target).hasClass("ativo")) {
            this.renderizarAba = false;
            this.hide();

            if ($("[aside-direita='valores-orcamento']").css('display') === 'block') {
                this.fixar(false);
            }

         
        } else {
            this.renderizarAba = true;
            this.show();

            if ($("[aside-direita='valores-orcamento']").css('display') === 'block') {
                this.fixar(true);
            }

        }
    },

    mostrarMenuOrcamento: function () {

        var self = this;

        if (self.fixado === 'True') {
            self.show('valores-orcamento');
        } else {
            self.hide();
        }
    },

    mostrarMenuCliente: function () {
        AsideDireita.show("cliente-pesquisa");
    },
    ocultarMenuCliente: function () {
        AsideDireita.hide("cliente-pesquisa");
    },

    mostrarPesquisaOrcamento: function () {
        AsideDireita.show("pesquisar-orcamento");
    },

    mostrarPesquisaProduto: function () {
        AsideDireita.show('pesquisar-produto');
    }
};

$(document).ready(function () {

    // $("[aside-direita='valores-orcamento']").hover(function () {

    //     if ($(this).hasClass('oculto')) {
    //         $('.icone-topo').css('right', '230px');
    //         $('#corpo_BaseInterno').css('margin-right', '230px');
    //         $('.button-group').removeClass('open');
    //     }

    // }, function () {

    //     if ($(this).hasClass('oculto')) {
    //         $('#corpo_BaseInterno').css('margin-right', '');
    //         $('.icone-topo').css('right', '0');
    //     }

    // });

    $("[aside-direita-action]").click($.proxy(AsideDireita.actionClick, AsideDireita));
    
});

